import type { NativeStackScreenProps } from "@react-navigation/native-stack";
import { observer } from "mobx-react-lite";
import React from "react";
import { useApi } from "../../core/apis";
import { useStores } from "../../core/stores";
import { FeedItemUI } from "../feed/ui/FeedItemUI";
import BusinessPlanScreen from "./BusinessPlanScreen";

type Props = NativeStackScreenProps<
  ReactNavigation.RootParamList,
  "BusinessFeedItem"
>;

export const BusinessPlanFeedItemScreen = observer((props: Props) => {
  const itemUid = props.route.params.itemUid;

  const { businessPlansStore } = useStores();
  const { businessFeedItemsApi } = useApi();
  const businessPlan = businessPlansStore.byId.get(
    props.route.params.businessUid,
  );

  const feedItem = businessPlan?.feedItems.find((item) => item.uid === itemUid);

  React.useEffect(() => {
    if (!feedItem && itemUid) {
      void businessFeedItemsApi.getById(itemUid);
    }
  }, [businessFeedItemsApi, feedItem, itemUid]);

  return (
    <BusinessPlanScreen {...props}>
      {feedItem && <FeedItemUI item={feedItem} />}
    </BusinessPlanScreen>
  );
});

export default BusinessPlanFeedItemScreen;
